@if (!isEmpty(get(subcategoryLinksRow, 'subcategory_links', ''))) {
  @for (row of get(subcategoryLinksRow, 'subcategory_links.subcategory_links', []); track row; let i = $index) {
    <div>
      <section id="rows" class="d-flex flex-column container align-items-center subcategory">
        <div class="category-top-title d-flex flex-row justify-content-center pb-2">
          @if (get(row, 'headline', '')) {
            <h2 class="col-md-7 text-center p-0">
              {{ row.headline }}
            </h2>
          }
        </div>
        <div class="grid partial-grid link-container">
          @for (subcategory of get(row, 'subcategory_links', []); track subcategory) {
            <a
              class="d-flex flex-row subcategory-link g-col-12 g-col-lg-4 g-col-md-6"
              [routerLink]="subcategory?.link?.href"
              >
              <div
                [style.background-image]="'url(' + getWebpImg('https://assets.sabrepc.com/img/spc/misc/partial/Subcat-bg.jpg') + ')'"
                class="subcategory-background d-flex flex-row align-items-center"
                >
                <div #systemImage>
                  @if (subcategory?.system_image?.href) {
                    <img
                      [src]="getWebpImg(subcategory.system_image.href)"
                      [alt]="subcategory.system_image.title"
                      />
                  }
                </div>
              </div>
              <div class="subcategory-text p-2">
                @if (subcategory?.category_name) {
                  <span class="bold font-color">{{ subcategory?.category_name }}</span>
                }
                @if (subcategory?.short_description) {
                  <p class="truncate-ellipsis">
                    {{ subcategory?.short_description }}
                  </p>
                }
                @if (subcategory?.link) {
                  <span class="learn-more link-purple">Learn More</span>
                }
              </div>
            </a>
          }
        </div>
      </section>
    </div>
  }
}
@if (get(subcategoryLinksRow, 'subcategory_links.split_line', '')) {
  <hr class="m-0" />
}
